// const bodymovin = require('bodymovin');
const lottie = require('lottie-web');

// $(function() {
//     $('.preloaderWrapper').fadeOut(1000);
// });

$('.preloader').each(function() {
    var figure1 = this;
    var canim1 = {
        container: this,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: themeURL + 'json/loader.json'
    };
    var anim = lottie.loadAnimation(canim1);
    anim.addEventListener('DOMLoaded', function(e) {
        // anim.playSegments([0, 45], true);
        // anim.playSegments([46, 98], false);
    });
});